// extracted by mini-css-extract-plugin
export var cardSelected = "_go-2";
export var image = "_go-1";
export var table = "_go-0";